import { render, staticRenderFns } from "./ActiveImei.vue?vue&type=template&id=2663008b&"
import script from "./ActiveImei.vue?vue&type=script&lang=js&"
export * from "./ActiveImei.vue?vue&type=script&lang=js&"
import style0 from "./ActiveImei.vue?vue&type=style&index=0&id=2663008b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports